"use client";

import { useEffect, useState } from "react";
import { useRouter, usePathname } from "next/navigation";
import { selectLanguage } from "@/app/redux/store";
import { useSelector } from "react-redux";
import Image from "next/image";
import { findOneUserById } from "@/app/adapters/api";

import { AtSign, MapPin, Phone } from "lucide-react";
import Link from "next/link";

import logoImpact from "@/app/assets/images/logo-impact-network.svg";
import logo from "@/app/assets/images/logo.svg";

import evpaLogo from "@/app/assets/images/evpa_logo.png";
import cnmvLogo from "@/app/assets/images/CNMV_logo.png";
import aefiLogo from "@/app/assets/images/aefi-trans_logo.png";
import spainNabLogo from "@/app/assets/images/spain-nab_logo.svg";
import impactEuropeLogo from "@/app/assets/images/impact-europe-white.svg";
import twitter from "@/app/assets/images/twitter.svg";
import impactAngelsLogo from "@/app/assets/images/impactangels.svg";
import euFundedLogo from "@/app/assets/images/eu-funded-logo.svg"
import enisaLogo from "@/app/assets/images/enisa-logo.svg"
import republicaPortuguesa1 from "@/app/assets/images/republica-portuguesa-1.png"

import Label from "@/app/features/web/label/Label";
import ContentContainer from "../content-container/contentContainer";

import { getLabels, getUserById } from "@/app/adapters/api";

const labelsNames = [
  "footer-street-address",
  "footer-city-zip",
  "footer-email",
  "footer-cnmv",
  "footer-contact-title",
  "footer-contact-1",
  "footer-faqs",
  "footer-advice-title",
  "footer-advice-1",
  "footer-advice-2",
  "footer-advice-3",
];

export default function Footer() {
  const lang = useSelector(selectLanguage);
  const [labels, setLabels] = useState<any>({});

  const pathname = usePathname()!;
  const [isOnImpactNetworkPage, setIsOnImpactNetworkPage] = useState(false);

  useEffect(() => {
    const userStored = localStorage.getItem("user");
    if (userStored) {
      const user = JSON.parse(userStored);
      findOneUserById(user.id).then((response) => {
        if (response.data.user.isOrizonMemberActive) {
          setIsOnImpactNetworkPage(true);
        }
      });
    }
    if (pathname.startsWith("/club-inversores-impact-network/")) {
      setIsOnImpactNetworkPage(true);
    }
    getLabels(labelsNames)
      .then((response) => {
        setLabels(response.data.labels);
      })
      .finally(() => {});
  }, []);

  return (
    <div className="w-full bg-[#FDF6F1]">
      <div className="mx-auto w-full max-w-[1200px] py-8 px-2">
        {/* Aviso importante */}
        <div
          className={
            isOnImpactNetworkPage
              ? "bg-secondary-impact-green flex flex-col md:flex-col justify-center p-8 rounded-xl"
              : "bg-lbs-primary-beige flex flex-col md:flex-col justify-center p-8 rounded-xl"
          }
        >
          <div className="flex justify-center">
            <h4 className="font-semibold text-lg text-center pb-5">
              <Label label={labels.footerAdviceTitle} lang={lang} />
            </h4>
          </div>
          <div className="flex flex-col items-start gap-4">
            <p className="font-medium">
              <Label label={labels.footerAdvice1} lang={lang} />
            </p>
            <ul className="pl-0">
              <ContentContainer label={labels.footerAdvice2} lang={lang} />
            </ul>
            <p>
              <ContentContainer label={labels.footerAdvice3} lang={lang} />
            </p>
          </div>
          {<div className="flex md:flex-row flex-col justify-center items-center gap-4 mt-8">
            <p className="font-semibold">
              <ContentContainer label={labels.footerCnmv} lang={lang} />
            </p>
          </div>}
        </div>

        
        <div className="flex flex-col md:flex-row justify-between py-8 mb-10 md:mb-6">

           {/* Logos */}
          <div className="py-4 md:px-4 px-10 flex md:justify-center justify-start items-start w-full md:w-1/4 gap-4">
            <div className="flex flex-col justify-center gap-4">
              <Link href="">
                <Image className="w-32" src={logo} alt="logo" />
              </Link>
              <Link target="_blank" href="https://impactangelsbs.com/">
                <Image
                  className="w-44"
                  width={170}
                  height={70}
                  src={impactAngelsLogo}
                  alt="logo"
                />
              </Link>
              <Image className='-ml-3' src={republicaPortuguesa1} alt="republica portuguesa" />
              <Image src={euFundedLogo} alt="europe funded logo" />
              <Image src={enisaLogo} alt="europe funded logo" />
            </div>
          </div>

           {/* Links */}
          <div className="py-4 md:px-4 px-10 flex flex-col w-full md:w-1/4 gap-3">
              <p className="font-extrabold text-lg">
                Bolsa Social
              </p>
              <Link href={`/ejemplos-de-inversion/`}>
                <p
                  className={
                    "text-black hover:underline"
                   /*  isOnImpactNetworkPage
                      ? `text-base font-bold hover:text-impact-green`
                      : `text-base font-bold hover:text-primary` */
                  }
                >
                  Portfolio
                </p>
              </Link>
              <Link href={lang === 'en' ? `/investment-products` : `/productos-inversion/`}>
                <p
                  className={
                    "text-black hover:underline"
                   /*  isOnImpactNetworkPage
                      ? `text-base font-bold hover:text-impact-green`
                      : `text-base font-bold hover:text-primary` */
                  }
                >
                  {lang === "en" ? "How it works" : "Cómo funciona"}
                </p>
              </Link>
              <Link href={lang === 'en' ? `/about-us`: `/quienes-somos/`}>
                <p
                  className={
                    "text-black hover:underline"
                   /*  isOnImpactNetworkPage
                      ? `text-base font-bold hover:text-impact-green`
                      : `text-base font-bold hover:text-primary` */
                  }
                >
                  {lang === "en" ? "About us" : "Quienes somos"}
                </p>
              </Link>
              <Link href={`/blog/`}>
                <p
                  className={
                    "text-black hover:underline"
                   /*  isOnImpactNetworkPage
                      ? `text-base font-bold hover:text-impact-green`
                      : `text-base font-bold hover:text-primary` */
                  }
                >
                  {lang === "en" ? "Blog" : "Blog"}
                </p>
              </Link>
              <Link href={`/registro-emprendedor/`}>
                <p
                  className={
                    "text-black hover:underline"
                   /*  isOnImpactNetworkPage
                      ? `text-base font-bold hover:text-impact-green`
                      : `text-base font-bold hover:text-primary` */
                  }
                >
                  {lang === "en" ? "I am entrepreneur" : "Soy emprendedor"}
                </p>
              </Link>
              <a href='/Tasa-de-Morosidad-2025.pdf' target='_blank'>
                <p
                  className={
                    "text-black hover:underline"
                   /*  isOnImpactNetworkPage
                      ? `text-base font-bold hover:text-impact-green`
                      : `text-base font-bold hover:text-primary` */
                  }
                >
                  {lang === "en" ? "Default rate" : "Tasa de Morosidad"}
                </p>
              </a>
              <Link href='https://blog.bolsasocial.com/wp-content/uploads/2024/10/Estimacion-crediticia-y-precio.pdf' target='_blank'>
                <p
                  className={
                    "text-black hover:underline"
                   /*  isOnImpactNetworkPage
                      ? `text-base font-bold hover:text-impact-green`
                      : `text-base font-bold hover:text-primary` */
                  }
                >
                  {lang === "en" ? "Credit rating and prices" : "Estimación crediticia y precios"}
                </p>
              </Link>
            
          </div>

          {/* Contacto */}
          <div className="py-4 md:px-4 px-10 flex flex-col w-full md:w-1/4 gap-3">
              <p className="font-extrabold text-lg">
                <Label label={labels.footerContactTitle} lang={lang} />
              </p>
              <Link href={`https://goparity.zendesk.com/hc/es-es`}>
                <p
                  className={
                      "text-lg text-black hover:underline"
                   /*  isOnImpactNetworkPage
                      ? "text-base font-semibold text-impact-green mt-4"
                      : "text-base font-semibold text-primary mt-4" */
                  }
                >
                  <h4 className="text-base">
                    FAQs
                  </h4>
                </p>
              </Link>
              <Link href={`/informacion-basica/`}>
                <p
                  className={
                    "text-base text-black hover:underline"
                    /* isOnImpactNetworkPage
                      ? "text-base font-semibold text-impact-green mt-4"
                      : "text-base font-semibold text-primary mt-4" */
                  }
                >
                  <h4 className="text-base">
                    {lang === "en" ? "Basic information" : "Información básica"}
                  </h4>
                </p>
              </Link>
              <Link href={`/privacidad/`}>
                <p
                  className={
                    "text-base text-black hover:underline"
                    /* isOnImpactNetworkPage
                      ? "text-base text-impact-green mt-4"
                      : "text-base text-primary mt-4" */
                  }
                >
                  <h4 className="text-base">
                    {lang === "en"
                      ? "Privacy policy"
                      : "Política de privacidad"}
                  </h4>
                </p>
              </Link>
              <Link href={`/cookies/`}>
                <p
                  className={
                    "text-base text-black hover:underline"
                    /* isOnImpactNetworkPage
                      ? "text-base text-impact-green mt-4"
                      : "text-base text-primary mt-4" */
                  }
                >
                  <h4 className="text-base">
                    {lang === "en" ? "Cookies policy" : "Política de cookies"}
                  </h4>
                </p>
              </Link>
              <Link href={`/condiciones-contratacion/`}>
                <p
                  className={
                    "text-base text-black hover:underline"
                    /* isOnImpactNetworkPage
                      ? "text-base text-impact-green mt-4"
                      : "text-base text-primary mt-4" */
                  }
                >
                  <h4 className="text-base">
                    {lang === "en" ? "Terms of use" : "Condiciones de uso"}
                  </h4>
                </p>
              </Link>
              <Link href="https://www.bolsasocial.com/back/docs/conflicto-de-interes-julio-2025.pdf" target='_blank'>
                <p
                  className={
                    "text-base text-black hover:underline"
                    /* isOnImpactNetworkPage
                      ? "text-base text-impact-green mt-4"
                      : "text-base text-primary mt-4" */
                  }
                >
                  <h4 className="text-base">
                    {lang === "en" ? "Conflict of interest" : "Conflicto de interés"}
                  </h4>
                </p>
              </Link>
              <p>
                Puedes contactar con nosotros a través de{" "}
                <a href="mailto:hello@goparity.com" className="text-primary hover:underline">
                  hello@goparity.com
                </a>
              </p>
            </div>

          {/* Miembros de: */}
          <div className="py-4 md:px-4 px-10 flex flex-col md:items-center w-full md:w-1/4">
              <p className="font-extrabold text-lg w-full md:text-center md:pb-4">
                {lang === "en" ? "Members of" : "Miembros de"}
              </p>
              <Image
                className="h-20 -ml-12 md:ml-0"
                src={spainNabLogo}
                alt="Spain Nab logo"
              />
              <Image
                  className="h-16 -ml-8 md:ml-0"
                  src={impactEuropeLogo}
                  alt="impact europe logo"
                />
              <div className="flex md:pl-8 items-center mt-4">
                <Link
                  href="https://www.linkedin.com/company/la-bolsa-social"
                  target="_blank"
                  className="mr-4"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 36 36"
                    fill="none"
                  >
                    <path
                      d="M0 9.94369H7.89423V35.7518H0V9.94369ZM30.2865 11.5377C31.8552 12.398 33.1456 13.701 34.1577 15.4469C35.1698 17.1927 35.6758 18.9765 35.6758 20.7983V35.7518H27.7057V20.7983C27.7057 20.3934 27.5539 19.938 27.2503 19.432C26.9466 18.9259 26.6683 18.597 26.4153 18.4452C26.0105 18.1922 25.4538 18.0656 24.7454 18.0656C24.0369 18.0656 23.4803 18.1669 23.0754 18.3693L19.8115 19.9633V35.7518H11.8413V9.94369H19.8115V11.1582C21.3802 10.4497 23.1513 10.1208 25.1249 10.1714C27.0985 10.222 28.819 10.6775 30.2865 11.5377ZM3.94711 0C5.0604 0 5.99658 0.37953 6.75564 1.13859C7.5147 1.89765 7.89423 2.83383 7.89423 3.94712C7.89423 5.0604 7.5147 6.00923 6.75564 6.79359C5.99658 7.57796 5.0604 7.97014 3.94711 7.97014C2.83383 7.97014 1.89765 7.57796 1.13859 6.79359C0.37953 6.00923 0 5.0604 0 3.94712C0 2.83383 0.37953 1.89765 1.13859 1.13859C1.89765 0.37953 2.83383 0 3.94711 0Z"
                      fill="black"
                    />
                  </svg>
                </Link>
                <Link
                  href="https://twitter.com/labolsasocial"
                  target="_blank"
                  className="mr-4"
                >
                  {/* <svg xmlns="http://www.w3.org/2000/svg" width="43" height="34" viewBox="0 0 43 34" fill="none">
                      <path fillRule="evenodd" clipRule="evenodd" d="M42.0191 3.9777C40.4739 4.65211 38.8136 5.10798 37.0704 5.31255C38.849 4.26282 40.2159 2.60043 40.8584 0.620711C39.1938 1.59258 37.3491 2.29921 35.3872 2.67829C33.8158 1.03094 31.5762 0 29.0978 0C24.3394 0 20.481 3.79729 20.481 8.48269C20.481 9.14689 20.5574 9.79499 20.7047 10.4162C13.5431 10.0624 7.19428 6.68499 2.94426 1.55231C2.20247 2.80555 1.77758 4.26336 1.77758 5.81728C1.77758 8.76029 3.29879 11.3559 5.61089 12.8776C4.19876 12.833 2.87008 12.4513 1.70831 11.8166C1.70722 11.852 1.70722 11.8869 1.70722 11.9234C1.70722 16.0322 4.6771 19.4606 8.61841 20.2408C7.89571 20.4335 7.13483 20.5377 6.34886 20.5377C5.79306 20.5377 5.25363 20.4851 4.72728 20.3857C5.82361 23.7551 9.00566 26.2084 12.7762 26.2771C9.82708 28.5516 6.11214 29.9085 2.07484 29.9085C1.37941 29.9085 0.693805 29.8688 0.019104 29.7898C3.83223 32.1964 8.36151 33.6 13.2273 33.6C29.0765 33.6 37.7435 20.6751 37.7435 9.46691C37.7435 9.09964 37.7347 8.73291 37.7184 8.36832C39.4032 7.17308 40.8644 5.67875 42.0191 3.9777Z" fill="black"/>
                    </svg> */}
                  <Image height={20} src={twitter} alt="twitter" />
                </Link>
                <Link
                  href="https://www.youtube.com/channel/UCf7zdoB-1v2TpmQfoyQd8Xg"
                  target="_blank"
                  className="mr-4"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 35 35"
                    fill="none"
                  >
                    <path
                      d="M1.75527 0H4.86591L6.89144 7.01702H7.10847L9.06166 0H12.1723L8.55527 10.2723V17.5064H5.44464V10.5617L1.75527 0ZM12.3893 7.5234C12.3893 6.51064 12.7751 5.71489 13.5468 5.13617C14.2702 4.55745 15.2588 4.26809 16.5127 4.26809C17.7184 4.26809 18.6588 4.58156 19.334 5.20851C20.0574 5.88369 20.4191 6.67943 20.4191 7.59574V14.3234C20.4191 15.4326 20.0815 16.2766 19.4063 16.8553C18.6347 17.5305 17.6461 17.8681 16.4404 17.8681C15.2347 17.8681 14.2461 17.5305 13.4744 16.8553C12.751 16.2284 12.3893 15.3603 12.3893 14.2511V7.5234ZM15.2829 14.4681C15.2829 14.8539 15.3794 15.1433 15.5723 15.3362C15.6687 15.4326 15.7773 15.505 15.8978 15.5532C16.0184 15.6014 16.1992 15.6255 16.4404 15.6255C16.778 15.6255 17.0673 15.505 17.3085 15.2638C17.5014 15.1191 17.5978 14.8539 17.5978 14.4681V7.45106C17.5978 7.1617 17.5014 6.94468 17.3085 6.8C17.1156 6.60709 16.8262 6.51064 16.4404 6.51064C16.0546 6.51064 15.7652 6.60709 15.5723 6.8C15.3794 6.94468 15.2829 7.1617 15.2829 7.45106V14.4681ZM30.6191 4.55745V17.5064H27.7978V16.0596C27.3638 16.5901 26.8333 17 26.2063 17.2894C25.6758 17.5787 25.1453 17.7234 24.6148 17.7234C24.0361 17.7234 23.5539 17.5305 23.168 17.1447C22.8305 16.6624 22.6617 16.0837 22.6617 15.4085V4.55745H25.4829V14.4681C25.4829 14.8539 25.5312 15.0709 25.6276 15.1191C25.7723 15.2638 25.9652 15.3362 26.2063 15.3362C26.351 15.3362 26.6163 15.2638 27.0021 15.1191C27.3879 14.8298 27.6531 14.5887 27.7978 14.3957V4.55745H30.6191ZM8.48293 17.8681H0.019104V20.1106H2.84038V33.7106H5.58932V20.1106H8.48293V17.8681ZM14.1255 30.8894C13.9326 31.1787 13.6673 31.3957 13.3297 31.5404C13.0886 31.6851 12.8716 31.7574 12.6787 31.7574C12.534 31.7574 12.3652 31.7092 12.1723 31.6128C12.0758 31.4199 12.0276 31.2028 12.0276 30.9617V21.9915H9.56804V31.8298C9.56804 32.505 9.71272 33.0113 10.0021 33.3489C10.2914 33.7347 10.7255 33.9277 11.3042 33.9277C11.7865 33.9277 12.2446 33.783 12.6787 33.4936C13.2092 33.2525 13.6914 32.8908 14.1255 32.4085V33.7106H16.5851V21.9915H14.1255V30.8894ZM24.9042 22.5702C24.4219 22.0879 23.8191 21.8468 23.0957 21.8468C22.7099 21.8468 22.3241 21.9433 21.9383 22.1362C21.6971 22.2326 21.3595 22.4979 20.9255 22.9319V17.8681H18.4659V33.7106H20.9255V32.8426C21.0702 33.0355 21.2269 33.1922 21.3957 33.3128C21.5645 33.4333 21.7453 33.5418 21.9383 33.6383C22.3723 33.783 22.8063 33.8553 23.2404 33.8553C23.9638 33.8553 24.5184 33.6383 24.9042 33.2043C25.29 32.8184 25.4829 32.1915 25.4829 31.3234V24.8128C25.4829 23.8482 25.29 23.1007 24.9042 22.5702ZM22.951 30.9617C22.951 31.3475 22.8787 31.6128 22.734 31.7574C22.5893 31.9504 22.3723 32.0468 22.0829 32.0468C21.9865 32.0468 21.7936 31.9986 21.5042 31.9021C21.3595 31.8539 21.1666 31.7092 20.9255 31.4681V24.1617C21.0702 24.017 21.239 23.8965 21.4319 23.8C21.5283 23.7518 21.6971 23.7277 21.9383 23.7277C22.2758 23.7277 22.5411 23.8241 22.734 24.017C22.8787 24.2582 22.951 24.5716 22.951 24.9574V30.9617ZM34.0191 28.1404V25.1745C34.0191 24.1135 33.7297 23.2454 33.151 22.5702C32.4758 21.9915 31.6078 21.7021 30.5468 21.7021C29.3893 21.7021 28.4971 22.0156 27.8702 22.6426C27.1468 23.3177 26.7851 24.1617 26.7851 25.1745V30.383C26.7851 31.444 27.0985 32.3362 27.7255 33.0596C28.4007 33.7347 29.2688 34.0723 30.3297 34.0723C31.5354 34.0723 32.4517 33.7589 33.0787 33.1319C33.7056 32.5532 34.0191 31.6369 34.0191 30.383V29.8043H31.4872V30.383C31.4872 31.0582 31.4149 31.4922 31.2702 31.6851C31.0773 31.878 30.7879 31.9745 30.4021 31.9745C30.0163 31.9745 29.7269 31.8539 29.534 31.6128C29.3893 31.4199 29.317 31.0099 29.317 30.383V28.1404H34.0191ZM29.317 25.1021C29.317 24.6199 29.4134 24.2823 29.6063 24.0894C29.751 23.8482 30.0163 23.7277 30.4021 23.7277C30.7397 23.7277 31.029 23.8482 31.2702 24.0894C31.4149 24.3305 31.4872 24.6681 31.4872 25.1021V26.3319H29.317V25.1021Z"
                      fill="black"
                    />
                  </svg>
                </Link>
                <Link
                  href="https://www.instagram.com/bolsasocial/"
                  target="_blank"
                  className="mr-4"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 36 36"
                    fill="none"
                  >
                    <path
                      d="M30.9665 14.8842H27.9454C28.191 15.7684 28.3138 16.6526 28.3138 17.5368C28.3138 19.0105 28.0314 20.4105 27.4665 21.7368C26.9016 23.0632 26.1279 24.2175 25.1454 25.2C24.163 26.1825 23.0086 26.9561 21.6823 27.5211C20.3559 28.086 18.9559 28.3684 17.4823 28.3684C16.0086 28.3684 14.6209 28.086 13.3191 27.5211C12.0173 26.9561 10.8752 26.1825 9.89279 25.2C8.91033 24.2175 8.13665 23.0632 7.57174 21.7368C7.00682 20.4105 6.72437 19.0105 6.72437 17.5368C6.72437 16.6526 6.84717 15.7684 7.09279 14.8842H3.99805V29.6947C3.99805 30.0877 4.13314 30.407 4.40331 30.6526C4.67349 30.8982 5.00507 31.0211 5.39805 31.0211H29.6402C30.0331 31.0211 30.3524 30.8982 30.5981 30.6526C30.8437 30.407 30.9665 30.0877 30.9665 29.6947V14.8842ZM30.9665 5.45263C30.9665 5.05965 30.8437 4.72807 30.5981 4.45789C30.3524 4.18772 30.0331 4.05263 29.6402 4.05263H25.5875C25.1945 4.05263 24.8752 4.18772 24.6296 4.45789C24.384 4.72807 24.2612 5.05965 24.2612 5.45263V9.43158C24.2612 9.82456 24.384 10.1561 24.6296 10.4263C24.8752 10.6965 25.1945 10.8316 25.5875 10.8316H29.6402C30.0331 10.8316 30.3524 10.6965 30.5981 10.4263C30.8437 10.1561 30.9665 9.82456 30.9665 9.43158V5.45263ZM17.4823 10.8316C15.6156 10.8316 14.0314 11.4825 12.7296 12.7842C11.4279 14.086 10.777 15.6702 10.777 17.5368C10.777 18.4702 10.9489 19.3544 11.2928 20.1895C11.6366 21.0246 12.1156 21.7491 12.7296 22.3632C13.3437 22.9772 14.0559 23.4561 14.8665 23.8C15.677 24.1439 16.5489 24.3158 17.4823 24.3158C18.4156 24.3158 19.2998 24.1439 20.1349 23.8C20.97 23.4561 21.6945 22.9772 22.3086 22.3632C22.9226 21.7491 23.4016 21.0246 23.7454 20.1895C24.0893 19.3544 24.2612 18.4702 24.2612 17.5368C24.2612 16.6035 24.0893 15.7316 23.7454 14.9211C23.4016 14.1105 22.9226 13.3982 22.3086 12.7842C21.6945 12.1702 20.97 11.6912 20.1349 11.3474C19.2998 11.0035 18.4156 10.8316 17.4823 10.8316ZM3.99805 35.0737C2.86823 35.0737 1.92261 34.6807 1.16121 33.8947C0.399806 33.1088 0.019104 32.1509 0.019104 31.0211V4.05263C0.019104 2.92281 0.399806 1.96491 1.16121 1.17895C1.92261 0.392982 2.86823 0 3.99805 0H30.9665C32.0963 0 33.0542 0.392982 33.8402 1.17895C34.6261 1.96491 35.0191 2.92281 35.0191 4.05263V31.0211C35.0191 32.1509 34.6261 33.1088 33.8402 33.8947C33.0542 34.6807 32.0963 35.0737 30.9665 35.0737H3.99805Z"
                      fill="black"
                    />
                  </svg>
                </Link>
              </div>
          </div>
        </div>
      </div>
    </div>
  );
}
